import { useEffect } from 'react';
import queryString from 'query-string';
import {
  AttributionKeys, MediaStatusValues, updateAttribution
} from './attribution_utils';
import { log, LOG_LEVELS } from '../../../common/config/app_logger';

const questionKey = 'powl_question';

const determineMediaStatus = (attributionParams) => (attributionParams[AttributionKeys.MediaSource]
  ? MediaStatusValues.NonOrganic
  : MediaStatusValues.Organic);

const decodeQuestionParam = (attributionParams) => {
  try {
    const questionParam = attributionParams[questionKey];
    if (questionParam !== undefined && questionParam !== '') {
      const questionText = decodeURIComponent(atob(questionParam));
      attributionParams.question = questionText;
    }
  } catch (error) {
    log(LOG_LEVELS.ERROR, 'Attribution', 'Failed to decode question', error);
  }
};

const processAttributionParams = (attributionParams) => {
  attributionParams[AttributionKeys.MediaStatus] = determineMediaStatus(attributionParams);
  decodeQuestionParam(attributionParams);
  return attributionParams;
};

const useWebAttribution = () => {
  useEffect(() => {
    const attributionParams = queryString.parse(window.location.search);
    const processedParams = processAttributionParams(attributionParams);
    updateAttribution(processedParams);
  }, []);
};

const WebAttribution = () => {
  useWebAttribution();
  return null;
};

export default WebAttribution;
